import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=6a5b287c&lang=pug&"
import script from "./navigation.vue?vue&type=script&lang=ts&"
export * from "./navigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports